import React, { useState, useEffect } from "react";
import { Button, Pagination } from "rsuite";
import { numberFormatter } from "../../utils";
import PlusRoundIcon from "@rsuite/icons/PlusRound";
import MinusRoundIcon from "@rsuite/icons/MinusRound";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

const CustomerSummaryTable = (props: any) => {
  const [limit, setLimit] = React.useState(10);

  useEffect(() => {
    console.log(props.data.list);
  }, [props]);

  return (
    <>
      <table className="supplierTable">
        <thead>
          <tr>
            <th rowSpan={2}>Customer</th>
            <th colSpan={4}>Recommendation</th>
            <th rowSpan={2}>Action</th>
          </tr>
          <tr>
            <th>Product Category</th>
            <th>Potential Quantity (eaches/year)</th>
            <th>Potential Revenue ($)</th>
            <th>Margin Opportunity ($)</th>
          </tr>
        </thead>
        <tbody>
          {Array.isArray(props.data.list) &&
            props?.data?.list?.map((d: any, index: any) => {
              return (
                <React.Fragment key={d.name + "_" + index}>
                  <tr
                    key={d.name}
                    onClick={() => {
                      props?.updateSelectedItem(d.id, d.name);
                      props?.updateSelectedProductList(d?.list);
                    }}
                    className={`cursor-pointer ${
                      props.selectedItem === d.id
                        ? "bg-[#006400]"
                        : "bg-inherit"
                    }`}
                  >
                    <td>
                      <div className="flex">
                        {props.selectedCustomerList === d.name ? (
                          <MinusRoundIcon
                            className="plusIcon"
                            onClick={() => {
                              props.updateSelectedCustomerList(null);
                            }}
                          />
                        ) : (
                          <PlusRoundIcon
                            className="plusIcon"
                            onClick={() => {
                              props.updateSelectedCustomerList(d.name);
                            }}
                          />
                        )}
                        <div> {d.name}</div>
                      </div>
                    </td>
                    <td>-</td>
                    <td>{numberFormatter(d.total.volume, 0)}</td>
                    <td>{numberFormatter(d.total.revenue, 0, "$")}</td>
                    <td>{numberFormatter(d.total.marginOpp, 0, "$")}</td>
                    <td>
                      <button className=" bg-green-700 px-2 py-1 rounded-md">
                        Accept
                      </button>
                    </td>
                  </tr>
                  {props.selectedCustomerList === d?.name &&
                    d?.list &&
                    d?.list.map((item: any, lIndex: any) => {
                      return (
                        <>
                          <tr>
                            <td></td>
                            <td>{item?.l4}</td>
                            <td>{numberFormatter(item.quantity, 0)}</td>
                            <td>{numberFormatter(item.currentRevenue, 0)}</td>
                            <td>
                              {numberFormatter(item.marginOpportunity, 0)}
                            </td>
                            <td>
                              <CheckBoxIcon
                                sx={{
                                  color: `${
                                    item.isAgreed == 0 ? "green" : "gray"
                                  }`,
                                }}
                                onClick={()=>{}}
                              />
                            </td>
                          </tr>
                        </>
                      );
                    })}
                </React.Fragment>
              );
            })}
        </tbody>
      </table>
      <div className="pagination-component">
        <Pagination
          prev
          next
          first
          last
          ellipsis
          boundaryLinks
          maxButtons={5}
          size="xs"
          layout={["-", "pager", "skip"]}
          total={props.count}
          limit={limit}
          activePage={props.pageNumber}
          onChangePage={(e) => {
            props.updatePageNumber(e);
          }}
        />
      </div>
    </>
  );
};
export default CustomerSummaryTable;
